module.exports = __webpack_public_path__ + "img/PABX.f3d984c9.png";